import { render, staticRenderFns } from "./revision.vue?vue&type=template&id=226e827d&scoped=true&"
import script from "./revision.vue?vue&type=script&lang=js&"
export * from "./revision.vue?vue&type=script&lang=js&"
import style0 from "./revision.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./revision.vue?vue&type=style&index=1&id=226e827d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226e827d",
  null
  
)

export default component.exports